import React from "react";
import { object } from "prop-types";
import { InputNumber as InputNumberA } from "antd";

export const InputNumber = props => <InputNumberA {...props} />;

InputNumber.propTypes = {
  style: object
};
